module.exports = __webpack_public_path__ + "static/media/emaSimple.88b022e2.PNG";